import { memo, useEffect } from "react";
import { useAtomValue, useSetAtom } from 'jotai';
import { currentProjectAtom } from "~/stores/ProjectStore";
import { isMapLoadedDoneAtom } from "../stores/mapStore";
import { CollectFormAPIs } from "~/common/typescript/apis/CollectFormAPIs";
import { availableFormsAtom, collectFormsPaginationAtom } from "../panels/GeocollectDatatablePanel/atoms/CollectFormAtoms";

/**
 * CollectFormController
 * Tự động tải và cache danh sách biểu mẫu (CollectForm) cùng thông tin cấu trúc trường
 * của dự án hiện tại, sẵn sàng phục vụ việc hiển thị nhãn/tiêu đề trường dữ liệu cho Map Popups và Panels.
 */
const CollectFormController = () => {
  const currentProject = useAtomValue(currentProjectAtom);
  const isMapLoadedDone = useAtomValue(isMapLoadedDoneAtom);
  const setAvailableForms = useSetAtom(availableFormsAtom);
  const setPagination = useSetAtom(collectFormsPaginationAtom);

  useEffect(() => {
    if (!isMapLoadedDone || !currentProject?.id) {
      return;
    }

    let isCancelled = false;

    const fetchForms = async () => {
      try {
        const response = await CollectFormAPIs.remote_CollectForm_getPage({
          projectId: currentProject.id,
          page: 1,
          pageSize: 100, // Tải danh sách form cho dự án hiện tại
        });

        if (!isCancelled && response?.results) {
          setAvailableForms(response.results);
          if (response.pagination) {
            setPagination({
              page: response.pagination.page,
              pageSize: response.pagination.pageSize,
              pageCount: response.pagination.pageCount,
              total: response.pagination.total,
            });
          }
        }
      } catch (err) {
        console.error('[CollectFormController] Error loading collect forms:', err);
      }
    };

    fetchForms();

    return () => {
      isCancelled = true;
    };
  }, [isMapLoadedDone, currentProject?.id, setAvailableForms, setPagination]);

  return null;
};

export default memo(CollectFormController);
